import { QuestionIcon } from "@chakra-ui/icons";
import { Button, Flex, Link, Text } from "@chakra-ui/react";
import IconBox from "../Icons/IconBox";
import React from "react";

export function SidebarHelp(props) {
  const { children } = props;
  return (
    <Flex
      borderRadius="15px"
      flexDirection="column"
      bg="teal.500"
      justifyContent="flex-start"
      alignItems="start"
      boxSize="border-box"
      p="16px"
      h="170px"
      w="100%"
    >
      <IconBox width="35px" h="35px" bg="white" mb="auto">
        <QuestionIcon color="teal.300" h="18px" w="18px" />
      </IconBox>
              <Text fontSize="sm" color="white" fontWeight="bold">
          نیاز به کمک دارید؟
        </Text>
        <Text fontSize="xs" color="white" mb="10px">
          راهنمای سیستم را مطالعه کنید
        </Text>
      <Link
        w="100%"
        href="#"
      >
        <Button
          fontSize="10px"
          fontWeight="bold"
          w="100%"
          bg="white"
          _hover="none"
          _active={{
            bg: "white",
            transform: "none",
            borderColor: "transparent",
          }}
          _focus={{
            boxShadow: "none",
          }}
          color="black"
        >
          راهنما
        </Button>
      </Link>
    </Flex>
  );
}
